import CategoryTableItemLoadingSkeleton from "../../../../../components/LoadingSkeletons/CategoryTableItemLoadingSkeleton";
import {
  ListBody,
  ListBodyCell,
  ListBodyItem,
  ListBodyItemAction,
  ListBodyItemNumberformat,
  ListHeader,
  ListHeaderItem,
  ListHeaderItemDropdown,
} from "../../../../../components/_widgets/WidgetsList";
import EmptyListContent from "./EmptyListContent";
import ListFilterHeader from "./ListFilterHeader";

const CategoryList = ({
  totalItems,
  isCategoriesLoading,
  qtLimitItem,
  handleSearch,
  setDeleteCategory,
  setCategory,
  setOpenDrawer,
  subCategories,
  setErrorMessage,
  setErrorName,
}) => {
  const handleEditCategory = (item) => {
    setCategory({
      ...item,
    });
    setOpenDrawer(true);
    setErrorMessage("");
    setErrorName(false);
    document.getElementById("btnCallEditCategory").click();
  };

  return (
    <>
      <ListHeader>
        <ListHeaderItem sizeLg={2} title={"Categoria"}>
          <ListHeaderItemDropdown>
            <li
              className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
              style={{ borderBottom: "1px solid #D9D9D9" }}
            >
              <div className="input-group input-search">
                <input
                  type="text"
                  style={{ width: "173px" }}
                  className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                  placeholder={"Procure por produto"}
                  onChange={({ target }) => handleSearch(target.value)}
                />

                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search " style={{ color: "#000000" }}></i>
                </span>
              </div>
            </li>
            <div className="filter-items" style={{ maxHeight: "238px" }}>
              <div onClick={() => handleSearch("")} className="dropdown-item">
                <span>Todos</span>
              </div>
              {subCategories?.map((item) => (
                <div key={item._id} onClick={() => handleSearch(item.name)} className="dropdown-item">
                  <span>{item.name}</span>
                </div>
              ))}
            </div>
          </ListHeaderItemDropdown>
        </ListHeaderItem>
        <ListHeaderItem sizeLg={3} title={"Produtos na Categoria"} />

        <ListHeaderItem sizeLg={3} title={"Adicionado em"}></ListHeaderItem>
      </ListHeader>
      <ListBody>
        {isCategoriesLoading ? (
          <>
            {/* <CategoryTableItemLoadingSkeleton />
            <CategoryTableItemLoadingSkeleton />
            <CategoryTableItemLoadingSkeleton />
            <CategoryTableItemLoadingSkeleton />
            <CategoryTableItemLoadingSkeleton />
            <CategoryTableItemLoadingSkeleton /> */}
          </>
        ) : totalItems === 0 ? (
          <EmptyListContent text={"Não existem categorias."} />
        ) : (
          subCategories?.map((item, index) =>
            index + 1 <= qtLimitItem ? (
              <ListBodyCell
                key={index}
                className={` cell-onhover c-pointer ${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}
              >
                <ListBodyItem
                  onClick={() => handleEditCategory(item)}
                  sizeLg={2}
                  description={"Categoria"}
                  title={item?.name}
                />
                <ListBodyItem
                  onClick={() => handleEditCategory(item)}
                  sizeLg={3}
                  description={"Produto na Categoria"}
                  title={item?.qty}
                />
                <ListBodyItem
                  onClick={() => handleEditCategory(item)}
                  sizeLg={3}
                  description={"Adicionado em"}
                  title={new Date(item?.createdAt).toLocaleDateString("pt-br")}
                />
                <ListBodyItemAction sizeLg={1} title={"edit"} margin={"ms-auto"}>
                  <li
                    onClick={() => {
                      handleEditCategory(item);
                    }}
                  >
                    <span className="dropdown-item fz-14 ff-univanova-regular c-pointer">Editar/Visualizar</span>
                  </li>
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#confirmDeleteProduct"
                    onClick={() => setDeleteCategory(item._id)}
                  >
                    <span className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer  text-cl-red">
                      Excluir
                    </span>
                  </li>
                </ListBodyItemAction>
              </ListBodyCell>
            ) : (
              <></>
            )
          )
        )}
        <button id="btnCallEditCategory" className="d-none" data-bs-toggle="modal" data-bs-target="#myModalSingle">
          Chamar modal confirm delete
        </button>
      </ListBody>
    </>
  );
};

export default CategoryList;
